module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/design-tile-images/design-tile-02-a1247133a42918d5b708415ae6da9c0b.webp";